module.exports = __webpack_public_path__ + "static/img/logo02.1d92cdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/App/logo02.png
// module id = IdYa
// module chunks = 1